import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@nextui-org/react';
import { Tasks } from 'common/src/utils/types';
import { deleteTask } from 'common/src/api/tasks';
import { toast } from 'react-toastify';

interface ModalDeleteTaskProps {
  isOpen: boolean;
  onClose: () => void;
  task: Tasks;
  fetchTasks: () => Promise<void>;
}

const ModalDeleteTask: React.FC<ModalDeleteTaskProps> = ({ isOpen, onClose, task, fetchTasks }) => {
  const onDelete = async () => {
    try {
      const res = await deleteTask(task.id);
      if (res) {
        fetchTasks();
        onClose();
        toast.success('Task deleted successfully');
      } else {
        toast.error('Error deleting the task');
      }
    } catch (error) {
      console.error('Error deleting task:', error);
      toast.error('Error deleting the task');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>Delete Task</ModalHeader>
        <ModalBody>
          ¿Estás seguro de que deseas eliminar la tarea de {task.name} {task.last_name}?
        </ModalBody>
        <ModalFooter>
          <Button color="default" variant="light" onPress={onClose}>
            Cancelar
          </Button>
          <Button color="danger" onPress={onDelete}>
            Eliminar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalDeleteTask;
